import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function Button({
  className,
  variant = 'primary',
  children,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn('inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none', variant === 'primary' ? 'bg-[#D4A59A] text-white hover:bg-[#c08e82] shadow-lg shadow-[#D4A59A]/20 focus:ring-[#D4A59A]' : 'bg-white text-[#4A4A4A] border-2 border-[#E5E5E5] hover:bg-[#F9F9F9] focus:ring-[#8B9D83]', className)} {...props} data-id="element-130">
      {children}
    </motion.button>;
}